import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import Typography from '@mui/material/Typography';

export const AddressTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const AddressRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  position: 'relative',
  backgroundColor: theme.palette.neutrals.beige1,
  borderRadius: '8px',
  minHeight: theme.spacing(10),
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  marginBottom: theme.spacing(3),
  cursor: 'pointer',
  '&.disabled': {
    cursor: 'not-allowed',
    opacity: 0.5
  }
}));

export const AddressIconBox = styled(Box)(({ theme }) => ({
  borderRadius: '50%',
  backgroundColor: theme.palette.neutrals.beige3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '48px',
  width: '48px',
  marginRight: theme.spacing(2),
  position: 'absolute',
  left: theme.spacing(2),
  top: theme.spacing(2)
}));

export const AddressIcon = styled(FmdGoodOutlinedIcon)(({ theme }) => ({
  color: theme.palette.neutrals.lead,
  fontSize: '2rem'
}));

export const AddressContent = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(8)
}));

export const AddressRadio = styled(Radio)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  '&.Mui-checked': {
    color: theme.palette.neutrals.lead
  }
}));
